angular.module('gym.mobile_app').directive('mobileAppSettingsWebsiteSettings', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/mobile_app/website_settings.html.slim'),
    scope: {
      onSettingsUpdated: '&',
      setTab: '&'
    },
    controller: ["$scope", "$rootScope", "$q", "$timeout", "MobileApp", "flash", "WebsiteResource", function($scope, $rootScope, $q, $timeout, MobileApp, flash, WebsiteResource) {
      var getBadge, validate, websiteUrl;
      $scope.gym = $rootScope.gym;
      WebsiteResource.doGET().then(function(website) {
        return $scope.website = website;
      });
      MobileApp.all('settings').getList().then(function(data) {
        $scope.settings = data[0];
        return $scope.settings.rootObjectName = 'gym_mobile_app_detail';
      });
      $scope.onToggle = function() {
        var base, base1, base2;
        (base = $scope.settings).request_access_page_title || (base.request_access_page_title = $scope.settings.default_request_access_page_title);
        (base1 = $scope.settings).request_access_page_message || (base1.request_access_page_message = $scope.settings.default_request_access_page_message);
        (base2 = $scope.settings).request_access_page_success_message || (base2.request_access_page_success_message = $scope.settings.default_request_access_page_success_message);
        return $scope.saveSettings();
      };
      validate = function() {
        var deferred, ref, ref1, ref2;
        deferred = $q.defer();
        $scope.errors = {};
        if (!((ref = $scope.settings.request_access_page_title) != null ? ref.trim() : void 0)) {
          $scope.errors.request_access_page_title = 'This field is required';
        }
        if (!((ref1 = $scope.settings.request_access_page_message) != null ? ref1.trim() : void 0)) {
          $scope.errors.request_access_page_message = 'This field is required';
        }
        if (!((ref2 = $scope.settings.request_access_page_success_message) != null ? ref2.trim() : void 0)) {
          $scope.errors.request_access_page_success_message = 'This field is required';
        }
        if (_.isEmpty($scope.errors)) {
          deferred.resolve();
        } else {
          deferred.reject();
        }
        return deferred.promise;
      };
      $scope.saveSettings = function() {
        return validate().then(function() {
          $scope.isLoading = true;
          return $scope.settings.save().then(function(data) {
            $scope.isLoading = false;
            $scope.settings = data;
            $scope.settings.rootObjectName = 'gym_mobile_app_detail';
            $scope.onSettingsUpdated({
              settings: $scope.settings
            });
            return flash.success = 'Updated successfully';
          }, function(response) {
            return $scope.isLoading = false;
          });
        });
      };
      $scope.websiteUrl = websiteUrl = function() {
        if (!$scope.website) {
          return null;
        }
        return `${window.location.protocol}//${window.location.host}/websites/${$scope.website.domain}`;
      };
      getBadge = function() {
        var businessType, country;
        country = (function() {
          switch ($scope.gym.country) {
            case 'GB':
              return 'uk';
            case 'AU':
              return 'au';
            default:
              return 'us';
          }
        })();
        businessType = (function() {
          switch ($scope.gym.business_type) {
            case 'MartialArts':
              return 'martial-arts-software';
            case 'Yoga':
              return 'yoga-studio-software';
            default:
              return 'personal-training-software';
          }
        })();
        return "<div style=\"text-align:center;padding-bottom:10px;\"> <div style=\"font-size:12px;color:#888;font-family:sans-serif;\">Powered by</div> <a href=\"https://www.clubworx.com/\"> <img src=\"https://app.clubworx.com/logo.svg\" style=\"height:20px;\"> </a> </div>";
      };
      $scope.getRequestAccessIframe = function() {
        return `<html>
  <body>
    <!-- EMBED START: Embed the following line somewhere in the BODY tag of your page: -->
    <iframe src=\"${websiteUrl()}/access_requests/iframe\" width=\"100%\" height=\"839\" border=\"0\" style=\"border:0;\">
    </iframe>
    ${getBadge()}
    <!-- EMBED END -->
  </body>
</html>`;
      };
      $scope.onRequestAccessHtmlCopied = function() {
        $scope.isRequestAccessHtmlCopied = true;
        $timeout(function() {
          return $scope.isRequestAccessHtmlCopied = false;
        }, 1000);
        return true;
      };
      $scope.goToAccessRequests = function() {
        return $scope.setTab({
          tab: {
            name: 'access_requests'
          }
        });
      };
      return $scope.pendingAccessRequestsCount = function() {
        return $rootScope.pendingAccessRequestsCount;
      };
    }]
  };
});
